import { Module } from 'vuex'
import kioskService from '@/services/kiosk.service'
import { KioskSettings } from '@/services/kiosk-settings'
import { BadgeSvgResponse } from '@/services/kiosk.types'

interface KioskState {
  settings: KioskSettings | null
  participantBadge: BadgeSvgResponse | null
}

const kioskStore: Module<KioskState, any> = {
  namespaced: true,
  state: () => ({
    settings: null,
    participantBadge: null,
  }),
  mutations: {
    SET_SETTINGS(state, payload: KioskSettings) {
      state.settings = payload
    },
    SET_PARTICIPANT_BADGE(state, payload: BadgeSvgResponse) {
      state.participantBadge = payload
    }
  },
  actions: {
    async getSettings({ commit }, event_uuid: string) {
      const data = await kioskService.getKioskSettings(event_uuid)
      commit('SET_SETTINGS', data)
      return data
    },
    async getAttendeeBadgeSVG ({ commit }, payload: { event_uuid: string, participant_uuid: string }) {
      const { event_uuid, participant_uuid } = payload
      const response = await kioskService.getAttendeeBadgeSVG(event_uuid, participant_uuid)
      const badgeData = response.data as BadgeSvgResponse
      badgeData.svg = badgeData.svg.substring(badgeData.svg.indexOf('<svg')) ?? ''
      commit('SET_PARTICIPANT_BADGE', badgeData)
      return badgeData
    }
  },
}

export default kioskStore
